export const ACADEMIC_PROGRESS = [
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '87',
          },
          {
            value: '85',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '75',
          },
          {
            value: '73',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '65',
          },
          {
            value: '63',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '65',
          },
          {
            value: '62',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '50',
          },
          {
            value: '48',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '70',
          },
          {
            value: '68',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '68',
          },
          {
            value: '65',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '70',
          },
          {
            value: '68',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '50',
          },
          {
            value: '30',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '50',
          },
          {
            value: '30',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '50',
          },
          {
            value: '30',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '50',
          },
          {
            value: '30',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '50',
          },
          {
            value: '30',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
  {
    metricHeaders: [
      {
        name: 'activeUsers',
        type: 'TYPE_INTEGER',
      },
      {
        name: 'newUsers',
        type: 'TYPE_INTEGER',
      },
    ],
    rows: [
      {
        metricValues: [
          {
            value: '50',
          },
          {
            value: '30',
          },
        ],
      },
    ],
    rowCount: 1,
    metadata: {
      currencyCode: 'USD',
      timeZone: 'America/Los_Angeles',
    },
    kind: 'analyticsData#runReport',
  },
];
